import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import homesLogo from '../assets/HOMES_LOGO.webp';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Validaciones básicas
    if (!formData.email || !formData.password) {
      setError({
        error: 'Por favor completa todos los campos',
        sugerencia: 'Asegúrate de llenar tanto el email como la contraseña.'
      });
      setLoading(false);
      return;
    }

    if (!formData.email.includes('@')) {
      setError({
        error: 'Por favor ingresa un email válido',
        sugerencia: 'El email debe contener el símbolo @ y un dominio válido.'
      });
      setLoading(false);
      return;
    }

    try {
      const result = await login(formData.email, formData.password);
      
      if (result.success) {
        navigate('/expedientes', { replace: true });
      } else if (result.requiereAprobacion) {
        navigate('/pending-approval');
      } else {
        if (typeof result.error === 'object' && result.error.error) {
          setError({
            error: result.error.error,
            sugerencia: result.error.sugerencia
          });
        } else {
          setError({
            error: result.error || 'Error desconocido',
            sugerencia: 'Inténtalo de nuevo o contacta al administrador.'
          });
        }
      }
    } catch (err) {
      setError({
        error: 'Error al conectar con el servidor',
        sugerencia: 'Verifica tu conexión a internet e inténtalo de nuevo.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container-homes">
      <div className="login-background">
        <div className="login-card-homes">
          <div className="login-header-homes">
            <img src={homesLogo} alt="HOMES Logo" className="login-logo" />
            <h1>Iniciar Sesión</h1>
            <p>Accede a tu cuenta de Gestor de Expedientes</p>
          </div>

          {error && (
            <div className="alert-homes-danger" style={{ marginBottom: '1.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <div style={{ marginRight: '10px', fontSize: '18px' }}>⚠️</div>
                <div style={{ flex: 1 }}>
                  <strong style={{ display: 'block', marginBottom: '5px' }}>{error.error}</strong>
                  {error.sugerencia && (
                    <small style={{ opacity: 0.8 }}>
                      💡 {error.sugerencia}
                    </small>
                  )}
                  <small style={{ opacity: 0.6, display: 'block', marginTop: '5px' }}>
                    ✏️ Corrige los datos y vuelve a intentar
                  </small>
                </div>
                <button
                  type="button"
                  onClick={() => setError(null)}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: 'inherit',
                    fontSize: '16px',
                    cursor: 'pointer',
                    padding: '4px 8px',
                    marginLeft: '10px',
                    borderRadius: '4px',
                    fontWeight: 'bold'
                  }}
                  title="Cerrar mensaje de error"
                >
                  ✕
                </button>
              </div>
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form-homes">
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-control"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="tu@email.com"
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                Contraseña
              </label>
              <div className="password-input" style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  className="form-control"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Tu contraseña"
                  required
                  disabled={loading}
                  style={{
                    paddingRight: '50px',
                    width: '100%'
                  }}
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowPassword(!showPassword);
                  }}
                  disabled={loading}
                  style={{
                    position: 'absolute',
                    right: '8px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '18px',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0',
                    zIndex: 10,
                    touchAction: 'manipulation'
                  }}
                >
                  {showPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="btn-homes-primary"
              disabled={loading}
            >
              {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </button>
            
            {error && (
              <button
                type="button"
                className="btn-homes-outline"
                onClick={() => {
                  setError(null);
                  setFormData({ email: '', password: '' });
                }}
                disabled={loading}
                style={{ marginTop: '1rem' }}
              >
                🗑️ Limpiar formulario y empezar de nuevo
              </button>
            )}
          </form>

          <div className="login-footer">
            <p>
              ¿No tienes cuenta?{' '}
              <Link to="/register" className="link">
                Regístrate aquí
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;





